export var DEFAULT_MARGINS = { top: 30, right: 10, bottom: 5, left: 10 };
export var GROUPED_GRADIENT = {
    default: {
        min: 0.2,
        max: 0.8,
    },
    disabled: {
        min: 0.05,
        max: 0.2,
    },
};
export var STACKED_GRADIENT = {
    default: {
        min: 0.3,
        max: 0.7,
    },
    disabled: {
        min: 0.05,
        max: 0.2,
    },
};
